export interface Specification {
  name: string;
  value: string;
  compare?: CompareType | null;
  highlight?: boolean;
}

export enum CompareType {
  WORSE = -1,
  EQUIVALENT = 0,
  BETTER = 1,
  EXCLUDED = '00',
}
